import { z } from 'zod';

export const AUTH_PROBE_DERIVATION_ATTEMPT_LIMIT = 3;

export const AuthProbeInjectionSourceSchema = z.enum([
  'headers',
  'cookies',
  'secrets',
  'localStorage',
  'sessionStorage',
]);

export const AuthProbeRequestSchema = z.object({
  method: z.literal('GET'),
  url: z.url().max(2048),
  headers: z.record(z.string().min(1).max(256), z.string().max(4096)),
});

export const AuthProbeInjectionSchema = z.object({
  source: AuthProbeInjectionSourceSchema,
  key: z.string().min(1).max(256),
  pattern: z.string().min(3).max(256),
});

export const AuthProbeSchema = z.object({
  request: AuthProbeRequestSchema,
  injections: z.array(AuthProbeInjectionSchema).min(1).max(20),
  expect: z.object({
    status: z.number().int().min(200).max(399),
  }),
});

export const AuthProbeDerivationStatusSchema = z.enum([
  'UNKNOWN',
  'READY',
  'UNAVAILABLE',
]);

export const AuthProbeRecordSchema = z.object({
  status: AuthProbeDerivationStatusSchema,
  probe: AuthProbeSchema.nullable(),
  attempts: z.number().int().min(0).default(0),
  lastAttemptAt: z.iso.datetime().nullable().default(null),
});

export type AuthProbeInjectionSource = z.infer<
  typeof AuthProbeInjectionSourceSchema
>;
export type AuthProbeRequest = z.infer<typeof AuthProbeRequestSchema>;
export type AuthProbeInjection = z.infer<typeof AuthProbeInjectionSchema>;
export type AuthProbe = z.infer<typeof AuthProbeSchema>;
export type AuthProbeDerivationStatus = z.infer<
  typeof AuthProbeDerivationStatusSchema
>;
export type AuthProbeRecord = z.infer<typeof AuthProbeRecordSchema>;
